import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class RealisationsSlider {
  constructor($el) {
    this.$el = $el;
    this.$wrapper = this.$el.parent();

    this.options = {
      autoPlay: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: false,
      freeScroll: false,
      cellSelector: ".home-realisations__single",
      cellAlign: "left",
    };

    if (this.$el.length) {
      this._init();
      // this._bindEvents();
    }
  }

  _init() {
    this.$slides = this.$el.find(".home-realisations__single");
    this.slidesCount = this.$slides.length;

    if (this.slidesCount > 0 && window.innerWidth < 1024) {
      this._createSlider();
    } else if (this.slidesCount > 4 && window.innerWidth >= 1024) {
      this._createSlider();
    }
  }

  _createSlider() {
    this.slider = new Flickity(this.$el[0], this.options);
  }

  // Voir products-cat-slider pour gérer le slider en fonction du nombre de slides (< 819px: plus de 1 slide; 820 à 1199px: plus de 2 slides; > 1200px: plus de 3 slides)
}

export default RealisationsSlider;
